import React, { useState, useEffect } from "react";
import "../../css/ContactProperty.css";
import LoadingSkeleton from "../../components/common/LoadingSkeleton";
import axios from "axios";
import useUser from "../../hooks/useUser";
import Listing from "../property/Listing";
import ConfirmationModal from "../modals/ConfirmationModal";
const ContactProperty = () => {
  const user = useUser();
  const [isOpen, setIsOpen] = useState(false);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [paginationInfo, setPaginationInfo] = useState({
    currentPage: 1,
    lastPage: 1,
    total: 0,
  });
   const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [msgTitle, setMsgTitle] = useState("");
    const [message, setMessage] = useState("");
    const [icon, setIcon] = useState("");
    const [theme, setTheme] = useState("");
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelect = (label) => {
    setSelectedItems(label);
  };

  const userId = user?.data?.id;

  const fetchPropertyData = async (userId, page = 1, perPage = 10) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/property-interactions/${userId}?query=contacted`,
        {
          params: {
            page,
            per_page: perPage,
            selectedItems,
          },
        }
      );
      if (response.data.status === "success") {
        setList(response.data.data.properties);
        setPaginationInfo({
          currentPage: response.data.data.current_page,
          lastPage: response.data.data.last_page,
          total: response.data.data.total,
          perPage: perPage,
        });

        setLoading(false);
      } else {
        setList([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response) {
        if (error.response.status === 404) {
            setShowConfirmModal(true);
            setMsgTitle("No properties found for the given filters.");
            setMessage();
            setIcon("fa fa-info-circle");
            setTheme("gold");
        } else {
            setShowConfirmModal(true);
            setMsgTitle("Failed to fetch data. Please try again.");
            setMessage();
            setIcon("fa fa-times-circle-o");
            setTheme("red");
        }
    }else {
        // error.response is undefined - network error, timeout, CORS, etc
        setShowConfirmModal(true)
        setMsgTitle('Something went wrong. Please check your connection.')
        setMessage()
        setIcon('fa fa-times-circle-o')
        setTheme('red')
      }
      setList([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPropertyData(userId, paginationInfo.currentPage);
  }, [selectedItems]);

  return (
    <div>
      <div className="d-flex justify-content-between ">
        <div className="title-header-filter breadcrumb">
          <div
            className="profile-path"
            data-aos="fade-right"
            data-aos-offset="300"
            data-aos-duration="300"
          >
            <span>Contacted Property</span>
            <span className="propcount">({list.length})</span>
          </div>
        </div>
        <div className="profdrpdwn dropdown border-bottom-0">
          <div
            className="profsortbx dropdown-toggle1"
            onClick={toggleAccordion}
          >
            <span>Sort</span>
            <svg
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.8024 6.63184H2.13574"
                stroke="#1C274C"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M16.3024 10.7988H4.63574"
                stroke="#1C274C"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M13.8024 14.9658H7.13574"
                stroke="#1C274C"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
          {isOpen && (
            <div
              className="dropdown-menu-sort d-block position-absolute"
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-duration="200"
            >
              <div
                className={`menu-item menu_item ${
                  selectedItems.includes("Relevance") ? "selected" : ""
                }`}
                onClick={() => handleSelect("Relevance")}
              >
                Relevance
              </div>

              <div
                className={`menu-item menu_item ${
                  selectedItems.includes("Price Asc") ? "selected" : ""
                }`}
                onClick={() => handleSelect("Price Asc")}
              >
                <span>Price</span>
                <svg
                  width="16"
                  height="24"
                  viewBox="0 0 16 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 18V23"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M10 13V23"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M15 8L15 23"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M1 14.5C3.5 13.5 9.6 9.5 14 1.5M14 1.5L10.5 3.5M14 1.5V5"
                    stroke="#343434"
                  />
                </svg>
              </div>

              <div
                className={`menu-item menu_item ${
                  selectedItems.includes("Price Desc") ? "selected" : ""
                }`}
                onClick={() => handleSelect("Price Desc")}
              >
                <span>Price</span>
                <svg
                  width="16"
                  height="23"
                  viewBox="0 0 16 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 17V22"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M6 12L6 22"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M1 7L1 22"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M1.35962 0.359374C2.35962 2.85937 6.35962 8.95937 14.3596 13.3594M14.3596 13.3594L12.3596 9.85937M14.3596 13.3594L10.8596 13.3594"
                    stroke="#343434"
                  />
                </svg>
              </div>

              <div
                className={`menu-item menu_item ${
                  selectedItems.includes("Area Asc") ? "selected" : ""
                }`}
                onClick={() => handleSelect("Area Asc")}
              >
                <span>Area</span>
                <svg
                  width="16"
                  height="24"
                  viewBox="0 0 16 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5 18V23"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M10 13V23"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M15 8L15 23"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M1 14.5C3.5 13.5 9.6 9.5 14 1.5M14 1.5L10.5 3.5M14 1.5V5"
                    stroke="#343434"
                  />
                </svg>
              </div>

              <div
                className={`menu-item menu_item ${
                  selectedItems.includes("Area Desc") ? "selected" : ""
                }`}
                onClick={() => handleSelect("Area Desc")}
              >
                <span>Area</span>
                <svg
                  width="16"
                  height="23"
                  viewBox="0 0 16 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11 17V22"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M6 12L6 22"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M1 7L1 22"
                    stroke="#343434"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M1.35962 0.359374C2.35962 2.85937 6.35962 8.95937 14.3596 13.3594M14.3596 13.3594L12.3596 9.85937M14.3596 13.3594L10.8596 13.3594"
                    stroke="#343434"
                  />
                </svg>
              </div>

              <div
                className={`menu-item menu_item ${
                  selectedItems.includes("Last Updated") ? "selected" : ""
                }`}
                onClick={() => handleSelect("Last Updated")}
              >
                Last Updated
              </div>

              <div
                className={`menu-item menu_item_last ${
                  selectedItems.includes("Date Added") ? "selected" : ""
                }`}
                onClick={() => handleSelect("Date Added")}
              >
                Date Added
              </div>
            </div>
          )}
        </div>
      </div>

      {loading ? (
        <LoadingSkeleton />
      ) : (
        <div className="main-area-contacted pt-2 pb-4">
          <Listing user={user} list={list} />
        </div>
      )}
      {showConfirmModal && (
        <ConfirmationModal
          onClose={() => setShowConfirmModal(false)}
          title={msgTitle}
          message={message}
          icon={icon}
          theme={theme}
        />
      )}
    </div>
  );
};

export default ContactProperty;
